import React, { MouseEventHandler, ReactNode, VFC } from 'react';
import styled from 'styled-components';
import { useTheme, Theme } from '@material-ui/core/styles';

const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 10px;

  ${({ theme }) => `
    ${theme.breakpoints.up('md')} {
      flex-direction: row;
      align-items: normal;
      font-size: 14px;
    }
  `}
`;
const Img = styled.img<{ theme: Theme }>`
  margin-right: 0;
  margin-bottom: 4px;

  ${({ theme }) => `
    ${theme.breakpoints.up('md')} {
      margin-right: ${theme.spacing(1)}px;
      margin-bottom: 0;
    }
  `}
`;
const Word = styled.p`
  margin: 0;
  word-break: keep-all;
`;

interface Props {
  src: string;
  alt: string;
  word: ReactNode;
  onClick?: MouseEventHandler;
}
const ImgIconWithWord: VFC<Props> = ({ src, alt, word, onClick }: Props) => {
  const theme = useTheme();
  return (
    <Wrapper theme={theme} onClick={onClick}>
      <Img src={src} alt={alt} width="18" height="18" theme={theme} />
      <Word>{word}</Word>
    </Wrapper>
  );
};

export default ImgIconWithWord;
